export default __webpack_public_path__ + "static/cp-purple-0c3d20fbdacea72e86b3688efc28a6a7.png";